import { render, staticRenderFns } from "./StarHead.vue?vue&type=template&id=3bbebe1d"
import script from "./StarHead.vue?vue&type=script&lang=js"
export * from "./StarHead.vue?vue&type=script&lang=js"
import style0 from "./StarHead.vue?vue&type=style&index=0&id=3bbebe1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports